import { render } from "./CreateVendorView.vue?vue&type=template&id=57c6fd55&scoped=true"
import script from "./CreateVendorView.vue?vue&type=script&lang=js"
export * from "./CreateVendorView.vue?vue&type=script&lang=js"

import "./CreateVendorView.vue?vue&type=style&index=0&id=57c6fd55&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c6fd55"]])

export default __exports__